import { render, staticRenderFns } from "./ContentPage.vue?vue&type=template&id=36148229&"
import script from "./ContentPage.vue?vue&type=script&lang=ts&"
export * from "./ContentPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports